import {Pipe, PipeTransform} from '@angular/core';
import {Util} from "../../app/util";

/**
 * Generated class for the DatetimePipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
    name: 'hourtime',
})
export class HourtimePipe implements PipeTransform {

    constructor(public util: Util) {


    }

    transform(value: string, segundo: boolean = false, separa: ':' | 'h' = 'h') { // ...args -> quando aceita infinitos argumentos?

        return this.util.horatime(value, segundo, separa);

    }

}



// WEBPACK FOOTER //
// ./src/pipes/hourtime/hourtime.ts